import React from 'react';
import './Physiotherapy.css';
import physiotherapyImage from '../../Assets/Physiotherapy.JPG';

const Physiotherapy = () => {
  return (
    <div className="residential-treatment-container">
      <img
        src={physiotherapyImage}
        alt="Physiotherapy"
        className="service-hero-image"
      />

      <div className="main-title">Physiotherapy at The Helping Hand Psychological Hospital</div>
      <div className="paragraph">
        At The Helping Hand Psychological Hospital, our Physiotherapy services are designed to help individuals restore movement, reduce pain, and improve physical function. Whether recovering from an injury, managing a neurological condition, or addressing developmental concerns, our experienced physiotherapists provide personalized, evidence-based treatment to support each client's health, independence, and quality of life.
      </div>

      <div className="sub-title">Our Areas of Expertise</div>
      <div className="paragraph">
        Our physiotherapists assess and treat a wide range of physical conditions, including:
      </div>
      <ul className="bullet-points">
        <li>Musculoskeletal injuries and pain</li>
        <li>Neurological conditions</li>
        <li>Stroke rehabilitation</li>
        <li>Sports injuries</li>
        <li>Post-operative rehabilitation</li>
        <li>Developmental delays in children</li>
        <li>Balance and coordination difficulties</li>
        <li>Postural problems</li>
        <li>Mobility and functional movement limitations</li>
      </ul>

      <div className="sub-title">Our Services</div>
      <div className="paragraph">
        We offer comprehensive physiotherapy services, including:
      </div>
      <ul className="bullet-points">
        <li>Comprehensive physiotherapy assessments</li>
        <li>Individualized treatment programmes</li>
        <li>Pain management and rehabilitation</li>
        <li>Therapeutic exercise programmes</li>
        <li>Manual therapy techniques</li>
        <li>Balance and gait training</li>
        <li>Strength and flexibility training</li>
        <li>Paediatric physiotherapy</li>
        <li>Home exercise programmes and progress monitoring</li>
      </ul>

      <div className="sub-title">Our Commitment to Better Movement and Recovery</div>
      <div className="paragraph">
        We believe that improved movement is essential for living a healthy, active, and independent life. Our physiotherapists are committed to delivering compassionate, evidence-based care tailored to each client's individual needs. By working closely with clients, families, and other healthcare professionals, we help individuals regain confidence, maximize their physical abilities, and achieve their rehabilitation goals.
      </div>
    </div>
  );
};

export default Physiotherapy;
